import { jsx as _jsx } from "react/jsx-runtime";
export function Input({ className = "", ...props }) {
    return (_jsx("input", { className: `w-full px-3 py-2 bg-duvi-surface border border-duvi-border rounded-[6px] text-duvi-text-primary placeholder:text-duvi-text-muted focus:outline-none focus:border-duvi-accent transition-colors ${className}`, style: { fontSize: "var(--text-sm)" }, ...props }));
}
//# sourceMappingURL=Input.js.map